import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { downloadExcel } from "react-export-table-to-excel";
import { Button, Select, Typography } from "antd";

import { RESET_COMPANIES } from "../WebKalkulator/modules/types";

const { Title, Text } = Typography;

const Score = ({ companies, scoring, actions }) => {
  const dispatch = useDispatch();
  const [showIzracun, setShowIzracun] = useState(false);

  useEffect(() => {
    if (scoring) {
      setShowIzracun(true);
    }
  }, [scoring]);

  const onSearch = (value) => {
    if (value.length < 4) {
      dispatch({
        type: RESET_COMPANIES,
      });
      setShowIzracun(false);
      return;
    }
    actions.getCompanies(value);
  };

  const handleClick = (companyId) => {
    if (!companyId) {
      return;
    }

    actions.getScoringForCompany(companyId);
  };

  const handleDownloadExcel = () => {
    const header = [
      "Naziv kompanije",
      "Financijska ocjena",
      "Rating klijenta",
      "OČEKIVANI EBITDA",
      "INDIKATOR KAPITALA",
    ];
    downloadExcel({
      fileName: `Scoring - ${scoring["Naziv kompanije"]}`,
      sheet: "react-export-table-to-excel",
      tablePayload: {
        header,
        body: [scoring],
      },
    });
  };

  return (
    <div className="p-8">
      <Title className="text-dark-blue text-xl font-bold mb-5">
        SCORING PRAVNA LICA
      </Title>
      <Text className="block h-5">
        Izračun se bazira prema aktuelnim podacima iz AFIP-a
      </Text>
      <Text className="block mb-6">
        Unesite JIB ili naziv kupca (minimalno četiri slova ili broja za
        pretragu)
      </Text>
      <Text className="block mb-1">Naziv klijenta</Text>

      <Select
        className="w-[360px]"
        showSearch
        defaultActiveFirstOption={false}
        suffixIcon={null}
        filterOption={false}
        onSearch={onSearch}
        notFoundContent={null}
        options={companies?.map((company) => ({
          value: company.companyId,
          label: company.name,
        }))}
        onSelect={(e) => {
          handleClick(e);
        }}
      />

      {showIzracun && (
        <>
          <div className="mt-10 mb-8 flex flex-col gap-5 shrink-0">
            <div>
              <Text>Naziv kompanije:</Text>
              <Text className="text-dark-blue font-bold">
                {" "}
                {scoring["Naziv kompanije"]}
              </Text>
            </div>
            <div>
              <Text>FINANCIJSKA OCJENA:</Text>
              <Text className="text-dark-blue font-bold">
                {" "}
                {scoring["Financijska ocjena"]}
              </Text>
            </div>
            <div>
              <Text>RATING KLIJENTA:</Text>
              <Text className="text-dark-blue font-bold">
                {" "}
                {scoring["Rating klijenta"]}
              </Text>
            </div>

            <div>
              <Text>OČEKIVANI EBITDA:</Text>
              <Text className="text-dark-blue font-bold">
                {" "}
                {scoring["OČEKIVANI EBITDA"]}
              </Text>
            </div>

            <div>
              <Text>INDIKATOR KAPITALA:</Text>
              <Text className="text-dark-blue font-bold">
                {" "}
                {scoring["INDIKATOR KAPITALA"]}%
              </Text>
            </div>
          </div>
          <Button
            htmlType="button"
            onClick={handleDownloadExcel}
            disabled={!scoring}
            className="text-white bg-light-blue w-[136px] rounded-sm border-light-blue shadow-sm"
          >
            PREUZMI EXCEL
          </Button>
        </>
      )}
    </div>
  );
};

export default Score;
